import styled from 'styled-components';

import { Colour, MinBreakpointV2, Shadow } from '@xemplo/style-constants';

export const ModalDialogBase = styled.dialog<{ $noBackdrop?: boolean }>`
  border: none;
  padding: 0;
  max-width: 100vw;
  max-height: 100vh;
  ${Shadow.Medium3}
  &::backdrop {
    background-color: ${Colour.Gray[900]};
    opacity: ${({ $noBackdrop }) => ($noBackdrop ? 0 : 0.6)};
  }
  @media ${MinBreakpointV2.medium} {
    border-radius: 8px;
  }
`;

export const ModalContainer = styled.div<{ $width?: number }>`
  display: flex;
  position: relative;
  flex-direction: column;
  background: ${Colour.Light[100]};
  width: 100vw;
  overflow: hidden;
  max-height: 100vh;

  @media ${MinBreakpointV2.medium} {
    width: ${({ $width }) => $width ?? 896}px;
    max-width: 896px;
    max-height: calc(100vh - 80px);
    border-radius: 8px;
  }
`;
